import { useCallback, useState } from 'react'

type SearchDraftProps = {
  searchValue?: string
  onSearchChange?: (value: string) => void
}

export function useUnifiedSearchDraft({ searchValue, onSearchChange }: SearchDraftProps) {
  const [internalDraft, setInternalDraft] = useState('')
  const controlled = searchValue !== undefined && onSearchChange !== undefined
  const draftValue = controlled ? searchValue : internalDraft

  const setDraftValue = useCallback(
    (value: string) => {
      if (controlled) {
        onSearchChange?.(value)
      } else {
        setInternalDraft(value)
      }
    },
    [controlled, onSearchChange],
  )

  return { draftValue, setDraftValue }
}
